import { FC, useEffect, useState, useRef} from "react";
import { Link, useLocation } from 'react-router-dom';

import styles from './styles.module.scss'
import { Logo } from "shared/ui/logo";
import { useMobileMenuContext } from "shared/contexts/mobile-menu-context";

let prevScrollpos = 0;

export const Header: FC = () => {
    const [top, setTop] = useState(0);
    const location = useLocation();
    const { isMobileMenuOpen, isMobile, toggleMobileMenu } = useMobileMenuContext();
    const headRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleScroll = () => {
            if (!headRef.current) return;

            const pos = window.scrollY;

            if (prevScrollpos > pos || pos < 50) {
                setTop(0);
            } else {
                setTop(-80);
            }
            prevScrollpos = pos;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const isEducationInfoPage = location.pathname === '/education-info';

    return (
        <>
            <div className={styles.before} />
            
            <div
                className={styles.header}
                ref={headRef}
                style={{ top: top }}
            >
                <div className={styles.__in}>

                    <div className={styles.logo}>
                        <Link to="/">
                            <Logo />
                        </Link>
                    </div>

                    {/* Показываем либо кнопку меню, либо навигацию */}
                    {isEducationInfoPage && isMobile ? (
                        <button 
                            className={`${styles.mobileMenuButton} ${isMobileMenuOpen ? styles.menuOpen : ''}`}
                            onClick={toggleMobileMenu}
                            data-mobile-menu-button
                            aria-label={isMobileMenuOpen ? "Закрыть меню" : "Открыть меню"}
                        >
                            <div className={styles.menuIcon}>
                                <span className={styles.hamburgerLine}></span>
                                <span className={styles.hamburgerLine}></span>
                                <span className={styles.hamburgerLine}></span>
                            </div>
                        </button>
                    ) : (
                        <div className={styles.menu}>
                            {!isEducationInfoPage ? (
                                <>
                                    <a href="#ansar">
                                        <div className={styles.li}>
                                            <span>Главная</span>
                                        </div>
                                    </a>
                                    <a href="#services">
                                        <div className={styles.li}>
                                            <span>Разработка</span>
                                        </div>
                                    </a>
                                    <a href="#courses">
                                        <div className={styles.li}>
                                            <span>Образование</span>
                                        </div>
                                    </a>
                                    <a href="#projects">
                                        <div className={styles.li}>
                                            <span>Проекты</span>
                                        </div>
                                    </a>
                                    <a href="#contacts">
                                        <div className={styles.li}>
                                            <span>Контакты</span>
                                        </div>
                                    </a>
                                    {/* <Link to="/education-info">
                                        <div className={styles.li}>
                                            <span>Сведения</span>
                                        </div>
                                    </Link> */}
                                </>
                            ) : (
                                <Link to="/">
                                    <div className={styles.li}>
                                        <span>← Назад на главную</span>
                                    </div>
                                </Link>
                            )}
                        </div>
                    )}

                </div>

            </div>
        </>
    );
};